var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viweBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 105A50 50 0 1 0 55 5a50 50 0 0 0 0 100Z",
    fill: "#FFDA7C",
    stroke: "#fff",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8 68.2c1.4 0 2.8.2 4.1.7a3.3 3.3 0 0 1 1.7 2c.3 1.2.4 2.4.4 3.6 0 1.2-.1 2.4-.5 3.5A3 3 0 0 1 74 80c-1.3.6-2.8.9-4.3.8H42.3a5.8 5.8 0 0 1-4.4-1.9 6.2 6.2 0 0 1-1.8-4.4c0-2.6 1-5 2.7-7 1.7-2.1 3.9-4 6.3-5.4l7.4-4.5c2.4-1.4 4.5-3 6.4-5a8.6 8.6 0 0 0 2.6-6 8 8 0 0 0-1.6-3.7c-.5-.5-1.1-1-1.8-1.3a8 8 0 0 0-5.7-.2c-.6.3-1.2.7-1.7 1.2-1 .8-1.7 2-1.9 3.2l-.3 1.7V50a5 5 0 0 1-.7 1.7c-.7 1.2-2.6 1.7-5.5 1.7-3.3 0-5.2-.9-5.8-2.6a19 19 0 0 1 4.9-16.6c3.4-4 8-5.9 13.6-5.9s10.2 2 13.7 5.9c3.4 3.6 5.3 8.4 5.3 13.3A18.3 18.3 0 0 1 68 61a33 33 0 0 1-9.2 6.3l-1.8.7v.3h12.8Z",
    fill: "#F36A7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.7fc3df3a99ada9a2d61df4e8ef3fd9bb.svg";
export { ForwardRef as ReactComponent };